const { toTitleCase } = require("Utils");

const TierConditionData = {
    TIER_POINTS: "TIER_POINTS",
    ORDER_COUNT: "ORDER_COUNT",
};

const TierConditionOptions = Object.values(TierConditionData).map((tCD) => ({
    label: toTitleCase(tCD),
    value: tCD,
}));

export { TierConditionData, TierConditionOptions };
